import { render, staticRenderFns } from "./errorBookV2.vue?vue&type=template&id=5517fc4b&scoped=true&"
import script from "./errorBookV2.vue?vue&type=script&lang=js&"
export * from "./errorBookV2.vue?vue&type=script&lang=js&"
import style0 from "./errorBookV2.vue?vue&type=style&index=0&id=5517fc4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517fc4b",
  null
  
)

export default component.exports